import { RenderFunc } from '../types/RenderFunc';

export const renderAgreementExecutionDecision: RenderFunc = item => {
  const { newValue, oldValue } = item;
  let oldValueText = '';
  let newValueText = '';

  if (oldValue === true) {
    oldValueText = 'Признать соглашение исполненным';
  } else if (oldValue === false) {
    oldValueText = 'Признать соглашение неисполненным';
  }
  if (newValue === true) {
    newValueText = 'Признать соглашение исполненным';
  } else if (newValue === false) {
    newValueText = 'Признать соглашение неисполненным';
  }

  return {
    renderedOldValue: oldValueText,
    renderedNewValue: newValueText,
  };
};
